import { useMutation } from 'react-query';
import { v4 as uuidv4 } from 'uuid';

// our axios
import adminAxiosInstance from 'services/API/ADMINAPI';

// our api urls
import { getMortechRatesUrl } from 'shared/api-urls';

// our utils
import formatMortechPayload from 'shared/utils/formatting/rates/formatMortechPayload';

function useMutateGetMortechRates() {
	return useMutation(async (rateDetails) => {
		const formattedMortechRateDetails = formatMortechPayload(rateDetails);

		const response = await adminAxiosInstance.post(
			getMortechRatesUrl,
			formattedMortechRateDetails
		);
		const mortechOffers = response.data;

		const filteredMortechByValidOffers = mortechOffers.filter((offer) => {
			const hasOffer = offer.lenderOffers['@items'] !== undefined;
			if (!hasOffer) return false;
			if (offer.lenderOffers['@items'].length === 0) return false;
			return true;
		});

		const simplifiedMortechOffers = filteredMortechByValidOffers.flatMap(
			(offer) => {
				return offer.lenderOffers['@items'].map((lenderOffer) => {
					return {
						...lenderOffer,
						id: uuidv4(),
						lenderName: lenderOffer.lenderName,
						fees: lenderOffer.lenderFees.totalFees,
						monthlyPayment:
							lenderOffer.monthlyPayment.totalMonthlyPayment,
						cashToClose: lenderOffer.settlementDetails.cashToClose,
						type: offer['@type']
					};
				});
			}
		);

		return simplifiedMortechOffers;
	});
}

export default useMutateGetMortechRates;
